import React from 'react';

export const MultiColumnFeatureData = [
	{
		id: 1,
		src: 'non-discretionary.svg',
		alt: 'Non-Discretionary',
		heading: 'Non-Discretionary',
		description:
			'The portfolio manager only suggests investment ideas and executes the investment; investment decisions are taken by the investor.',
	},
	{
		id: 2,
		src: 'discretionary.svg',
		alt: 'Discretionary',
		heading: 'Discretionary',
		description: [
			'Investment decisions are taken by the ',
			<strong>investment manager</strong>,
			'.',
		],
	},
];
